import { useState } from 'react';
import { Line } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import './chartConfig';
import { LineChartData } from './types';

interface StoreComparisonChartProps {
  chartData: {
    income: LineChartData;
    sales: LineChartData;
  };
}

function StoreComparisonChart({ chartData }: StoreComparisonChartProps) {
  const { t } = useTranslation();
  const [mode, setMode] = useState<'income' | 'sales'>('income');

  const activeData = mode === 'income' ? chartData.income : chartData.sales;

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top' as const,
      },
      tooltip: {
        callbacks: {
          label: function (context: any) {
            const label = context.dataset.label || '';
            if (mode === 'income') {
              return `${label}: € ${context.parsed.y.toLocaleString('nl-NL', { minimumFractionDigits: 2 })}`;
            }
            return `${label}: ${context.parsed.y.toLocaleString('nl-NL')}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value: any) {
            if (mode === 'income') {
              return `€ ${value.toLocaleString('nl-NL')}`;
            }
            return value.toLocaleString('nl-NL');
          },
        },
      },
    },
  };

  return (
    <div>
      <div className="filter-container">
        <h3>{t('financialdashboard.comparison-chart-title')}</h3>
          <div className="filter-group">
            <div className="period-buttons">
              <span
                className={`range-label ${mode === 'income' ? 'active' : ''}`}
                onClick={() => setMode('income')}
              >
                {t('financialdashboard.income')}
              </span>
              <span
                className={`range-label ${mode === 'sales' ? 'active' : ''}`}
                onClick={() => setMode('sales')}
              >
                {t('financialdashboard.sales')}
              </span>
            </div>
          </div>
      </div>
      {activeData.datasets.length > 0 ? (
        <Line data={activeData} options={options} />
      ) : (
        <p>{t('financialdashboard.select-stores-none')}</p>
      )}
    </div>
  );
}

export default StoreComparisonChart;
